@if (chat()) {
  <div class="chat-container" data-cy="iot-platform-ui-chat" fxLayout="column">
    @if (chat()?.header) {
      <iot-platform-ui-chat-header [header]="$safeNavigationMigration(chat()?.header)" (dispatchAction)="dispatchAction.emit($event)" />
    }
    <iot-platform-ui-chat-body (dispatchAction)="dispatchAction.emit($event)" [body]="$safeNavigationMigration(chat()?.body)" fxFlex />
    @if (chat()?.footer) {
      <iot-platform-ui-chat-footer [footer]="chat().footer" (dispatchAction)="dispatchAction.emit($event)" />
    }
  </div>
}
